// Staff choice and the confirmed paid assignment take precedence over planning.
// A planned session is a default only; it grants no admission until staff save.
export const getOrchestraSessionChoice = (group, choices = {}) =>
    choices[group.id] ?? group.assignment?.sessionId ?? group.plannedSession?.sessionId;
